import axios from "axios";
import React, {createContext, useEffect, useState} from "react";

const AuthContext = createContext();

function AuthContextProvider(props) {
	const [loggedIn, setLoggedIn] = useState(undefined);
	const [user, setUser] = useState([]);

	async function getLoggedIn() {
		/**Backend will check whether user is logged in or not */
		const loggedInRes = await axios.get(`${process.env.REACT_APP_API_URL}/auth/loggedIn`, {withCredentials: true});
		setLoggedIn(loggedInRes.data.auth);
		setUser(loggedInRes.data.user); /**data
    {
    "auth": true,
    "user": {
        "_id": "6691085a1327e9005296dbeb",
        "name": "abc",
        "age": 200,
        "gender": "male",
        "bloodGroup": "A+",
        "email": "abc@gmail.com",
        "phone": 123456789,
        "state": "Andhra Pradesh",
        "district": "Anantapur",
        "address": "20"
    }
}
*/
	}

	//getLoggedIn will be called everytime a webpage using the contextHook is loaded (since the component will be mounted)
	//It will set logged in user status

	useEffect(() => {
		getLoggedIn();
	}, []);

	return <AuthContext.Provider value={{loggedIn, user, getLoggedIn}}>{props.children}</AuthContext.Provider>;
}

export default AuthContext;
export {AuthContextProvider};
